import React from "react";
import { Box, Link } from "@mui/material";
import Typography from "components/basic/typography";

import DocLink from "./components/DocLink";
import ProfileRow from "../../../../../ProfileRow";
import { formatDate } from "../../../../../../helpers";
import { AdminVendor } from "../../../../../../types";

/** What a vendor submitted at sign-up, for checking before verifying them. */
const VendorProfile: React.FC<{ vendor: AdminVendor }> = ({ vendor }) => {
  const v = vendor.vendor;

  return (
    <Box>
      <Typography variant="h5" style={{ fontWeight: 600, marginBottom: 8 }}>
        Business
      </Typography>
      <ProfileRow
        label="Owner"
        value={`${vendor.ownerName ?? "—"} · ${vendor.ownerEmail ?? "—"}`}
      />
      <ProfileRow label="Team accounts" value={vendor.accountCount} />
      <ProfileRow label="Phone" value={v.phoneNumber} />
      <ProfileRow label="Address" value={v.address} />
      <ProfileRow label="Province" value={v.province} />
      <ProfileRow
        label="Website"
        value={
          v.businessWebsite && (
            <Link
              href={v.businessWebsite}
              target="_blank"
              rel="noopener noreferrer"
            >
              {v.businessWebsite}
            </Link>
          )
        }
      />
      <ProfileRow label="Organization type" value={v.organizationType} />
      {v.rejectionReason && (
        <ProfileRow label="Rejection reason" value={v.rejectionReason} />
      )}
      {v.reverificationReasons.length > 0 && (
        <ProfileRow
          label="Changes to review"
          value={v.reverificationReasons.join(", ")}
        />
      )}
      {v.pauseReason && (
        <ProfileRow label="Paused because" value={v.pauseReason} />
      )}
      <ProfileRow label="Joined" value={formatDate(v.createdAt)} />

      <Typography
        variant="h5"
        style={{ fontWeight: 600, margin: "16px 0 8px" }}
      >
        Contacts
      </Typography>
      <ProfileRow
        label="Primary"
        value={`${v.primaryContactFirstName} ${v.primaryContactLastName} (${v.primaryContactPosition}) · ${v.primaryContactEmail} · ${v.primaryContactPhone}`}
      />
      <ProfileRow
        label="Signatory"
        value={
          v.primaryContactIsSignatory
            ? "Primary contact"
            : `${v.signatoryFirstName} ${v.signatoryLastName} (${v.signatoryPosition}) · ${v.signatoryEmail} · ${v.signatoryPhone}`
        }
      />

      <Typography
        variant="h5"
        style={{ fontWeight: 600, margin: "16px 0 8px" }}
      >
        Registration
      </Typography>
      <ProfileRow
        label="GST/HST registration number"
        value={v.businessNumber}
      />
      <ProfileRow
        label="Proof of insurance"
        value={<DocLink url={v.proofOfInsuranceURL} />}
      />
      <ProfileRow
        label="Business license"
        value={<DocLink url={v.businessLicenseURL} />}
      />
      <ProfileRow
        label="Offers EV installation"
        value={v.offeringEvInstallation}
      />
      {v.offeringEvInstallation === "Yes" && (
        <>
          <ProfileRow
            label="Electrical license #"
            value={v.electricalLicenseNumber}
          />
          <ProfileRow
            label="Electrical license"
            value={<DocLink url={v.electricalLicenseURL} />}
          />
        </>
      )}
    </Box>
  );
};

export default VendorProfile;
